import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CreateDrillBody, CreateDrillResponse, DrillsService } from '@drills/infra';
import { toDrillViewModel } from '../../../mappers';
import { CreateDrillCommandPayload } from './create-drill.command-payload';
import { CreateDrillCommandResult } from './create-drill.command-result';

export class CreateDrillCommandHandler {
  private readonly drillsService: DrillsService = inject(DrillsService);

  execute(payload: CreateDrillCommandPayload): Observable<CreateDrillCommandResult> {
    const body: CreateDrillBody = {
      name: payload.name,
      type: payload.type,
      scoring: payload.scoring,
      shotsCount: payload.shotsCount,
      description: payload.description,
      favorite: payload.favorite
    };
    return this.drillsService.create(body).pipe(
      map((dto: CreateDrillResponse) => ({
        drillId: dto.id,
        drill: toDrillViewModel(dto)
      }))
    );
  }
}
